module.exports = __webpack_public_path__ + "static/media/television.b841a130.svg";